// import React from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
// import 'swiper/css/effect-coverflow';
// import 'swiper/css/pagination';
// import 'swiper/css/navigation';
// import SwiperCore from 'swiper/core';
// import { EffectCoverflow, Pagination, Navigation, Autoplay } from 'swiper/modules';
// import '../pages/gallery.css';

// SwiperCore.use([EffectCoverflow, Pagination, Navigation, Autoplay]);

// function GalleryCard({ title, i1, i2, i3, i4, i5, i6, i7 }) {
//     return (
//         <div className="container-gallery shadow">
//             <h1 className="heading-gallery">{title}</h1>
//             <Swiper
//                 effect={'coverflow'}
//                 grabCursor={true}
//                 centeredSlides={true}
//                 loop={true}
//                 slidesPerView={'auto'}
//                 autoplay={{
//                     delay: 1500, // Adjust the delay as needed
//                     disableOnInteraction: false,
//                 }}
//                 coverflowEffect={{
//                     rotate: 0,
//                     stretch: 0,
//                     depth: 100,
//                     modifier: 2.5,
//                 }}
//                 pagination={{ el: '.swiper-pagination', clickable: true }}
//                 navigation={{
//                     nextEl: '.swiper-button-next',
//                     prevEl: '.swiper-button-prev',
//                     clickable: true,
//                 }}
//                 className="swiper_container"
//             >
//                 <SwiperSlide>
//                     <img src={i1} alt="slide_image" />
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <img src={i2} alt="slide_image" />
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <img src={i3} alt="slide_image" />
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <img src={i4} alt="slide_image" />
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <img src={i5} alt="slide_image" />
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <img src={i6} alt="slide_image" />
//                 </SwiperSlide>
//                 <SwiperSlide>
//                     <img src={i7} alt="slide_image" />
//                 </SwiperSlide>

//                 <div className="slider-controler">
//                     <div className="swiper-button-prev slider-arrow">
//                         <ion-icon name="arrow-back-outline"></ion-icon>
//                     </div>
//                     <div className="swiper-button-next slider-arrow">
//                         <ion-icon name="arrow-forward-outline"></ion-icon>
//                     </div>
//                     <div className="swiper-pagination"></div>
//                 </div>
//             </Swiper>
//         </div>
//     );
// }

// export default GalleryCard;
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import SwiperCore from 'swiper/core';
import { EffectCoverflow, Pagination, Navigation, Autoplay } from 'swiper/modules';
import '../pages/gallery.css';
// import 'bootstrap/dist/css/bootstrap.min.css';

SwiperCore.use([EffectCoverflow, Pagination, Navigation, Autoplay]);

function GalleryCard({ title, i1, i2, i3, i4, i5, i6, i7 }) {
    return (
        <div className="container-gallery shadow">
            <h1 className="heading-gallery">{title}</h1>
            <Swiper
                effect={'coverflow'}
                grabCursor={true}
                centeredSlides={true}
                loop={true}
                slidesPerView={'auto'}
                autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                }}
                coverflowEffect={{
                    rotate: 0,
                    stretch: 0,
                    depth: 100,
                    modifier: 2.5,
                }}
                pagination={{ el: '.swiper-pagination', clickable: true }}
                navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                    clickable: true,
                }}
                className="swiper_container"
            >
                {[i1, i2, i3, i4, i5, i6, i7].map((image, index) => (
                    <SwiperSlide key={index}>
                        <img src={image} alt={`slide_image_${index}`} className="img-fluid p-0 p-md-3" />
                    </SwiperSlide>
                ))}
                <div className="slider-controler">
                    <div className="swiper-button-prev slider-arrow">
                        <ion-icon name="arrow-back-outline"></ion-icon>
                    </div>
                    <div className="swiper-button-next slider-arrow">
                        <ion-icon name="arrow-forward-outline"></ion-icon>
                    </div>
                    <div className="swiper-pagination"></div>
                </div>
            </Swiper>
        </div>
    );
}

export default GalleryCard;
